export class PushNotificationsDispatchApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDispatchHistory({ page, pageSize } = {}) {
    return this.#http.get('api/push-notifications/dispatch/history', {
      params: { page, pageSize },
    });
  }
}
